const browserStorage = window.sessionStorage;

const storage = {
  getToken: () => browserStorage.getItem("token"),
  setToken: token => browserStorage.setItem("token", token),
  discardToken: () => browserStorage.removeItem("token"),
}

export default storage;
